<template>
    <div class="rf-view waiting-verification-view">
        <WholesalerLogo :wholesaler="customer.wholesaler" :customer="customer" :customerNumber="customerNumber" />
        <main>
            <h1>
                {{ $t('waitingForVerification.title') }}
            </h1>
            <p>{{ $t('waitingForVerification.description') }}</p>
        </main>
    </div>
</template>


<script lang="ts">
import { InputBox, WholesalerLogo } from "@restofrit/components"
import { Session } from "@restofrit/networking";
import { Customer, CustomerStatus } from "@restofrit/structures";
import { ArrayDecoder, Decoder } from "@simonbackx/simple-encoding";
import { ErrorBox } from "@simonbackx/simple-error-forms";
import { ComponentWithProperties, NavigationController, NavigationMixin } from "@simonbackx/vue-app-navigation";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";

import PromotionsView from "../promotions/PromotionsView.vue";
import TabBarController from "../promotions/TabBarController.vue";
import { TabBarItem } from "../promotions/TabBarItem";
import SettingsView from "../settings/SettingsView.vue";

@Component({
    components: {
        InputBox,
        WholesalerLogo
    },
})
export default class WaitingForVerificationView extends Mixins(NavigationMixin) {
    @Prop({ required: true })
    customer: Customer

    @Prop({ required: true })
    customerNumber: number
    
    errorBox: ErrorBox | null = null
    loading = false

    reloading = false

    @Watch('customer.settings.status')
    onChangeStatus() {
        console.log("Customer status changed")
        if (this.customer.settings.status == CustomerStatus.Accepted) {
            this.viewPromotions()
        }
    }

    viewPromotions() {
        this.show({
            components: [
                new ComponentWithProperties(TabBarController, {
                    items: [
                        new TabBarItem("promotions.title", "promotions", new ComponentWithProperties(NavigationController, { 
                            root: new ComponentWithProperties(PromotionsView, {
                                customer: this.customer,
                                customerNumber: this.customerNumber
                            })
                        })),
                        new TabBarItem("settings.title", "settings", new ComponentWithProperties(NavigationController, { 
                            root: new ComponentWithProperties(SettingsView, {
                                customer: this.customer,
                                customerNumber: this.customerNumber
                            })
                        }))
                    ]
                })
            ],
            animated: true,
            replace: 1,
            force: true
        })
    }
    
}
</script>

<style lang="scss">
.waiting-verification-view {

    .logo {
        height: 100px;
        display: block;
        margin: 0 auto;
        margin-bottom: 20px;
    }
}
</style>